// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pa-0";
export var buttonContainer = "_pa-3";
export var cancelButton = "_pa-4";
export var headerSection = "_pa-6";
export var headerTitle = "_pa-9";
export var messageSideLeft = "_pa-1";
export var messageSideRight = "_pa-2";
export var orderNumberContainer = "_pa-7";
export var orderNumberLabel = "_pa-8";
export var submitButton = "_pa-5";